export default __webpack_public_path__ + "static/media/css.c34ab495.svg";